export var GetSportClubUsersOrderBy;
(function (GetSportClubUsersOrderBy) {
    GetSportClubUsersOrderBy["firstName"] = "firstName";
    GetSportClubUsersOrderBy["lastName"] = "lastName";
    GetSportClubUsersOrderBy["clubMemberSince"] = "clubMemberSince";
    GetSportClubUsersOrderBy["lastActivityDate"] = "lastActivityDate";
    GetSportClubUsersOrderBy["isAdmin"] = "isAdmin";
    GetSportClubUsersOrderBy["isOwner"] = "isOwner";
})(GetSportClubUsersOrderBy || (GetSportClubUsersOrderBy = {}));
